module.exports = __webpack_public_path__ + "static/media/raven_sad_03.b9c7d5e9.svg";